export interface PublicationProfileOption {
  value: number;
  label: string;
}

export interface PublicationProfileRequest {
  publicationBookType: number;
  publicationTextReady: number;
  publicationTimeframe: number;
  publicationBudget: number;
}

export const PUBLICATION_BOOK_TYPE_OPTIONS: PublicationProfileOption[] = [
  { value: 1, label: 'TCC' },
  { value: 2, label: 'Doutorado' },
  { value: 3, label: 'Mestrado' },
  { value: 4, label: 'Autoral' },
];

export const PUBLICATION_TEXT_READY_OPTIONS: PublicationProfileOption[] = [
  { value: 1, label: 'Sim' },
  { value: 2, label: 'Não' },
];

export const PUBLICATION_TIMEFRAME_OPTIONS: PublicationProfileOption[] = [
  { value: 1, label: 'Imediatamente' },
  { value: 2, label: 'Em 30 a 60 dias' },
  { value: 3, label: 'Em 90 dias ou mais' },
];

export const PUBLICATION_BUDGET_OPTIONS: PublicationProfileOption[] = [
  { value: 1, label: 'Tenho R$3.500 ou mais disponível agora' },
  { value: 3, label: 'Ainda estou me organizando financeiramente' },
];

/** Label da opção correspondente ao valor gravado no banco ('—' quando não preenchido) */
export function publicationProfileLabel(options: PublicationProfileOption[], value?: number | null): string {
  if (value == null) return '—';
  return options.find(o => o.value === value)?.label ?? String(value);
}

